/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import Swiper from "swiper";
import 'swiper/css';
import { apigetallbooksdata } from "../../services/apigetbooks/apigetbooks";
import apiurl from "../../../admin/shared/services/apiendpoint/apiendpoint";
import useCartStore from "../../services/store/usecart";
import toast from 'react-hot-toast'
import { apisavecart } from "../../services/apicart/apicart";
import useAuth from "../../services/store/useAuth";
import { Tooltip } from "@nextui-org/react";
import Cartsidebar from "../CheckoutandCart/Cartsidebar";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

const BookImageSkeleton = () => (
    <div className="animate-pulse">
        <div className="w-full h-64 bg-gray-300 rounded-t-md"></div>
    </div>
);

export default function Studymaterials() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const { userdetails } = useAuth();
    const [books, setBooks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filteredBooks, setFilteredBooks] = useState([]);
    const [selectedBookType, setSelectedBookType] = useState("All");
    const [bookTypes, setBookTypes] = useState([]);
    const {addToCart, cart: cartItems, cart} = useCartStore();
    let isMounted = true;

    useEffect(() => {
        const fetchBooks = async () => {
          try {
            const data = await apigetallbooksdata({});
            const sortedBooks = (data.resdata || []).sort((a, b) => {
              const posA = parseInt(a.Position) || Infinity;
              const posB = parseInt(b.Position) || Infinity;
              return posA - posB;
            });
            
            setBooks(sortedBooks);
            setFilteredBooks(sortedBooks);
            
            const types = ["All", ...new Set(sortedBooks.map(book => book.Book_Type).filter(Boolean))];
            setBookTypes(types);
            setIsLoading(false);
          } catch (error) {
            console.error("Failed to fetch books:", error);
            setIsLoading(false);
          }
        };
        
        if (isMounted) {
          fetchBooks();
        }
      }, [isMounted]);

       useEffect(() => {
            if (selectedBookType === "All") {
                setFilteredBooks(books);
            } else {
                setFilteredBooks(books.filter(book => book.Book_Type === selectedBookType));
            }
        }, [selectedBookType, books]);

    useEffect(() => {
        if (books.length > 0) {
            new Swiper(".bookslider", {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                autoplay: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        }
    }, [books]);

    const handleAddToCart = async (book) => {
        const userDetails = userdetails;
        if (!userDetails) {
            toast.error("Please log in to add items to your cart!");
            return;
        }

        if (userDetails.Role === "Student") {
            toast.error("Students cannot make purchases. Please login with a customer account.");
            return;
        }

        // Check if item is out of stock
        if (book.Quantity === 0) {
            toast.error("This item is currently out of stock!");
            return;
        }
        const cartItemsFromStore = cartItems || [];
        if (cartItemsFromStore.some(item => item.productId._id === book._id)) {
            toast.error("Product is already in your cart!");
            return;
        }
        try {
            const cartData = { productId: book._id, Email: userDetails.Email, Quantity: 1 };
            await apisavecart(cartData);

            addToCart(book);
            toast.success("Product added to cart successfully!");
    
        } catch (error) {
            toast.error("Failed to add product to cart.");
            console.error("Error adding product to cart:", error);
        }
    };

    const getStockStatus = (quantity) => {
        if (quantity === undefined || quantity === null) {
            return { text: "In Stock", color: "bg-green-100 text-green-800" };
        }
        if (quantity === 0) {
            return { text: "Out of Stock", color: "bg-red-100 text-red-800" };
        }
        if (quantity < 10) {
            return { text: "Low Stock", color: "bg-yellow-100 text-yellow-800" };
        }
        return { text: "In Stock", color: "bg-green-100 text-green-800" };
    };

    const toggleSidebar = () => { setIsSidebarOpen(!isSidebarOpen); };
    
    return (
        <>
         <HelmetProvider>
                <Helmet>
                  <meta charset="UTF-8" />
                  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                  <title>Kavin&apos;s Academy - Study materials</title>
        
                  <meta name="keywords" content="Kavins Academy Salem,UPSC coaching Salem,TNPSC coaching Salem,Competitive exams coaching Tamil Nadu,IBPS coaching Salem,TET coaching Salem,TRB coaching Salem,DRB coaching Salem,Best UPSC classes Salem,Best TNPSC coaching Salem,Online coaching for UPSC TNPSC,Offline classes for competitive exams Salem,Competitive exam coaching Salem Tamil Nadu,UPSC TNPSC IBPS coaching Kavins Academy,Government exams coaching Salem,Bank exams coaching Salem,Kavins Academy competitive exams,Salem Tamil Nadu coaching classes,UPSC classes Tamil Nadu,TNPSC coaching Tamil Nadu,Kavins Academy ,UPSC coaching center,TNPSC coaching ,Competitive exams coaching Tamil Nadu,IBPS coaching ,TET coaching Salem,TRB coaching ,DRB coaching ,Best UPSC classes Salem,Best TNPSC coaching ,Online coaching for UPSC TNPSC,Offline classes for competitive exams ,Competitive exam coaching  Tamil Nadu,UPSC TNPSC IBPS coaching Kavins Academy,Government exams coaching ,Bank exams coaching ,Kavins Academy UPSC coaching
                TNPSC coaching center,Competitive exams coaching Tamil Nadu,IBPS coaching institute,TET coaching classes,TRB coaching for teachers,DRB coaching center,UPSC online coaching
                TNPSC online classes,Competitive exams preparation Tamil Nadu,Best coaching for UPSC TNPSC,Bank exams coaching institute,Government exams coaching center,Online and offline coaching for competitive exams,UPSC TNPSC IBPS coaching,Top competitive exams institute,UPSC preparation classes,Coaching classes for government exams,Tamil Nadu exam coaching,Kavins Academy exam preparation" />
        
                  <meta name="description" content="Kavins Academy is a premier coaching institute specializing in competitive exam preparation for aspirants across Tamil Nadu. 
                  We offer both online and offline classes tailored for exams such as UPSC, TNPSC, IBPS, TET-TRB, and SRD/DRB (Cooperative)." />
        
                  <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
                  <meta property="og:type" content="website" />
                  <meta property="og:image" content="/images/logo/favicon.png" />
        
                  <meta property="og:title" content="Kavin's Academy - An Ultimate Destination fo UPSC, TNPSC, IBPS, TET-TRB, SRD/DRB (Coop) Aspirants" />
        
                  <meta property="og:description" content="Kavins Academy is a premier coaching institute specializing in competitive exam preparation for aspirants across Tamil Nadu. 
                  We offer both online and offline classes tailored for exams such as UPSC, TNPSC, IBPS, TET-TRB, and SRD/DRB (Cooperative)." />
        
                  <meta property="og:url" content="https://www.kavinsacademy.com" />
                  <meta property="og:site" content="Kavin's Academy" />
                  <meta property="og:site_name" content="Kavin's Academy" />
                  <link rel="canonical" href="https://www.kavinsacademy.com" />
                  <meta name="facebook-domain-verification" content="0c59n4w2e5jlf2wlrjc7jjky6tzeuj" />
        
                  <meta name="twitter:card" content="summary_large_image" />
                  <meta name="twitter:site" content="@kavinsacademy" />
                  <meta name="twitter:title" content="Kavin's Academy | Distance Education in Tamil Nadu" />
                  <meta name="twitter:description" content="With a dedicated team of experienced educators, we provide comprehensive study materials, personalized coaching, and result-oriented strategies to help students achieve their goals. " />
                  <meta name="twitter:image" content="/images/logo/favicon.png" />
        
                </Helmet>
              </HelmetProvider>
            <section className="bg-[url('/images/about/bg-img.jpg')] bg-center bg-no-repeat overflow-hidden">
                <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-17 mx-auto">
                    <div className="grid grid-cols-1 gap-6 text-center md:gap-6">
                        <div>
                            <h1 className="mb-3 text-3xl font-extrabold text-white lg:text-5xl">Study Materials</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-12 mx-auto">
                    <div className="flex items-center justify-between mb-6">
                        <div className="flex items-center gap-3">
                            <label htmlFor="bookTypeFilter" className="text-lg font-semibold text-gray-700">Filter by Book Type:</label>
                            <select id="bookTypeFilter" value={selectedBookType} onChange={(e) => setSelectedBookType(e.target.value)}
                                className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                {bookTypes.map((type) => (
                                    <option key={type} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="text-sm text-gray-600">
                            Showing {filteredBooks.length} {filteredBooks.length === 1 ? 'book' : 'books'}
                        </div>
                    </div>
                     <div className="grid grid-cols-2 gap-6 md:grid-cols-3 lg:grid-cols-5 md:gap-6">
                        {isLoading 
                            ? Array(10).fill().map((_, index) => (
                                <div className="border-2 rounded-md animate-pulse" key={index}>
                                    <div className="flex justify-between p-2">
                                        <div className="h-6 bg-gray-300 rounded-full w-14"></div>
                                        <div className="w-20 h-6 bg-gray-300 rounded-full"></div>
                                    </div>
                                    <div className="p-5 rounded-xl">
                                        <BookImageSkeleton />
                                    </div>
                                    <div className="flex items-center justify-center">
                                        <div className="w-24 h-6 mx-5 bg-gray-300 rounded"></div>
                                    </div>
                                    <div className="grid grid-cols-1 text-white">
                                        <div className="p-3 text-center bg-gray-300">
                                            <div className="w-full h-6 bg-gray-400 rounded"></div>
                                        </div>
                                    </div>
                                </div>
                            ))
                            : filteredBooks.length > 0 ? (
                                filteredBooks.map((book) => {
                                    const stockStatus = getStockStatus(book.Quantity);
                                    return (
                                        <div className="border-2 rounded-md" key={book._id}>
                                        <div className="flex justify-between p-2">
                                            <h1 className="px-2 mx-3 text-white bg-green-600 rounded-full w-fit">
                                                {book.Discount}%
                                            </h1>
                                            <span className={`px-3 py-1 text-xs font-medium rounded-full ${stockStatus.color}`}>
                                                {stockStatus.text}
                                            </span>
                                        </div>
                                        <div className="p-5 rounded-xl">
                                            <div className="w-full h-full swiper bookslider">
                                                <div className="swiper-wrapper">
                                                    {book.Book_image.map((imgSrc, index) => (
                                                        <div className="swiper-slide" key={index}>
                                                             <Link to={`/view-product/${book._id}`} state={{ product: book }}>
                                                                <img src={`${apiurl()}/${imgSrc}`} alt={`Cover of ${book.Book_Name}`} className="object-cover w-full h-64 rounded-t-md" loading="lazy" />
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="swiper-button-next"></div>
                                                <div className="swiper-button-prev"></div>
                                            </div>
                                        </div>
                                        <div className="flex items-center justify-center">
                                            <h1 className="relative mx-5 text-lg font-bold lg:text-xl -top-2">
                                                ₹ {book.Sale_Price} 
                                                <span className="mx-1 text-base font-normal">
                                                    <s>₹ {book.Regular_Price}</s>
                                                </span>
                                            </h1>
                                        </div>
                                        <div className="grid grid-cols-1 text-white">
                                            <div className="p-3 text-center text-black bg-regal-yellow">
                                                <button onClick={() => handleAddToCart(book)} className={`font-semibold ${book.Quantity === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                                                    disabled={book.Quantity === 0}>
                                                    {book.Quantity === 0 ? 'Out of Stock' : 'Add To Cart'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    );
                                })
                            ) : (
                                <div className="col-span-full">
                                    <div className="flex flex-col items-center justify-center py-12 text-gray-500">
                                        <svg className="w-16 h-16 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        <p className="text-lg font-semibold">No books found</p>
                                        <p className="text-sm">Try selecting a different book type</p>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </section>

            <div className="fixed z-50 flex flex-col items-end space-y-8 bottom-4 right-4">
                <div className="relative" onClick={toggleSidebar}>
                    <img src="/images/shopping-cart.png" alt="Cart" className="cursor-pointer w-14 h-14" />
                    <span className="absolute flex items-center justify-center w-6 h-6 text-xs text-white bg-red-600 rounded-full -top-2 -right-2">
                        {cart.length}
                    </span>
                </div>

                <a href="https://wa.me/9047127777?text=Hello%20I%20want%20to%20enquire%20about%20your%20services" target="_blank" rel="noopener noreferrer">
                    <Tooltip color="success" content="Contact on WhatsApp Now!" placement="left" showArrow={true}>
                        <img src="/images/whatsapp.png" alt="WhatsApp" className="w-14 h-14 animate-bounce-up-down" />
                    </Tooltip>
                </a>
            </div>
            <Cartsidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        </>
    );
}